export default __webpack_public_path__ + "static/media/stadium.a6a7e8e8.jpg";